export default class MarkdownUtils {
    public static table(
        header: string[],
        contents: string[][],
        options?: { dropEmptyColumns?: boolean }
    ) {
        if (options?.dropEmptyColumns) {
            const emptyCols = new Set<number>()
            for (let i = 0; i < contents[0].length; i++) {
                if (contents.every((row) => row[i] === undefined || row[i].trim().length === 0)) {
                    emptyCols.add(i)
                }
            }
            for (let i = header.length - 1; i >= 0; i--) {
                if (emptyCols.has(i)) {
                    header.splice(i, 1)
                    for (const row of contents) {
                        row.splice(i, 1)
                    }
                }
            }
        }

        let result = ""

        result += "\n\n| " + header.join(" | ") + " |\n"
        result += header.map(() => "-----").join("|") + " |\n"
        for (const line of contents) {
            if (!line) {
                continue
            }
            result += "| " + line.map((x) => x ?? "").join(" | ") + " |\n"
        }
        result += "\n\n"
        return result
    }

    static list(strings: string[]): string {
        if (strings.length === 0) {
            return ""
        }
        return "\n\n" + strings.map((item) => " - " + item).join("\n") + "\n\n"
    }
}
